import React, { useContext } from "react";
import Header from "./header";
import Footer from "./footer";
import Faq from "./faq";

import { useState, useEffect } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";


import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";











function PartnershipDeed() {
   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
         const parsedUser = JSON.parse(storedUser);
         setNewData((prevData) => ({
            ...prevData,
            user_name: parsedUser.name || "",
            user_email: parsedUser.email || "",
            user_contact_number: parsedUser.mobile || "",
            user_related_query: parsedUser.city || "",
         }));
      }
   }, []);


   const { http, token } = AuthUser();
   const navigate = useNavigate();
   const [activeQuestion, setActiveQuestion] = useState(null);

   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };


   const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact_number: '', user_related_query: '' })

   const [errors, setErrors] = useState({});
 
   const { services, loading, error } = useContext(ServicesContext);


   if (loading) {
      return <div>Loading...</div>;  // Show loading state while fetching data
   }

   if (error) {
      return <div>{error}</div>;  // Show error state if there was an issue fetching data
   }
   const service = services.find(s => s.service_id === 1);



   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }

      if (!newData.user_email.trim()) {
         newErrors.user_email = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

      if (!newData.user_contact_number.trim()) {
         newErrors.user_contact_number = '*number is required.';
      } else if (!/^\d{10}$/.test(newData.user_contact_number)) {
         newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
      }


      // if (!newData.user_contact_number.trim()) {
      //    newErrors.user_contact_number = '*number is required.';
      //  } else if (!/^\d{10}$/.test(newData.user_contact_number)) {
      //    newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
      //  }

      if (!newData.user_related_query) {
         newErrors.user_related_query = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };

   // const formPutPartenshipdeed = async (e) => {
   //    e.preventDefault();
   //    if (validateForm()) {
   //       try {
   //          console.log("Form Data to Submit:", newData); // Debugging
   //          const data = await PartenerSheepDeedService.partenerShipDeedForm(newData);
   //          setNewData({
   //             user_name: '',
   //             user_email: '',
   //             user_contact_number: '',
   //             user_related_query: '',
   //          });
   //          alert("Form submitted successfully!");
   //       }
   //       catch (error) {
   //          console.log(error);
   //       }
   //    }


   // };

   const formPutPartenshipdeed = async (e) => {
      e.preventDefault();

      if (!validateForm()) return;

      try {
         const response = await PartenerSheepDeedService.partenerShipDeedForm(newData);

         console.log("API Success:", response);

          // Show success screen after successful submission
        navigate("/thankyou");

         // alert("Form submitted successfully!");

         // Optional: reset form
         setNewData(prev => {
            const resetObj = {};
            Object.keys(prev).forEach(key => (resetObj[key] = ""));
            return resetObj;
         });

         console.log("reset");

      } catch (error) {
         console.error("API Error:", error);
         alert("Something went wrong!");
      }
   };




   // const formPutPartenshipdeed = async (e) => {
   //    e.preventDefault();




   //    // if (!token) {
   //    //    alert("Please log in to continue.");
   //    //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path

   //    //    navigate('/login');
   //    //    return;
   //    // }


   //    if (!validateForm()) return;

   //    // Save data in localStorage or state manager
   //    localStorage.setItem("bookingData", JSON.stringify(newData));

   //    // Navigate to checkout
   //    navigate('/checkout', {
   //       state: {
   //          service: service,

   //       }
   //    });

   // };


   const handleBannerClick = () => {
      const formElement = document.querySelector(".contact3-form-all");
      console.log('shake-effect Applied');

      if (formElement) {
         formElement.classList.add("shake-effect");

         // remove effect after animation finishes
         setTimeout(() => {
            formElement.classList.remove("shake-effect");
         }, 400); // same as animation duration
      }
   };







   return (
      <div >

         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2  ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <h1 className="sk-text-color">Partnership Registration
                        </h1>
                        <h2 >Legalize Your Partnership</h2>
                        <p className="pdrl-text">Get Partnership Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Stamp Duty as per actual Extra)</span></p>
                        <p className="pd-text">A Partnership Registration
                           is a crucial legal document that defines the terms and conditions between partners in a business, ensuring clarity and avoiding disputes. Governed by the Indian Partnership Act of 1932, it outlines profit-sharing, responsibilities, and other key aspects of the partnership. Let the experts at Dm2Legal assist you in drafting a legally sound Partnership Registration
                           tailored to your business needs.
                        </p>

                        <div className="banner" onClick={handleBannerClick}>
                           <img src="assets/icons/banner.svg" alt="" />
                        </div>

                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Book Service Now </h3>
                           <p className="pdrl-text">at Rs.{service?.price}/- Only  <span><br />(Stamp Duty as per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })}
                                             />

                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Email Address<span className="red">*</span></label>   {errors.user_email && <p className="error-text">{errors.user_email}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />

                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Contact Number<span className="red">*</span></label> {errors.user_contact_number && <p className="error-text">{errors.user_contact_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />

                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">

                                       <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_related_query"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>

                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />


                  </div>
                  {/* <RazorpayButton amount={service?.price} /> */}



               </div>

               <div className="space40"></div>


               <div className="row">
                  <div className="col-lg-6">
                     <img src="assets/img/service/service7-main-image.png" alt="" />

                  </div>

                  <div className="col-lg-6">
                     <p className="pd-text">A Partnership Registration
                        is a legally binding document that clearly outlines the rights, duties, and profit-sharing arrangements between partners in a business. It helps prevent disputes and ensures smooth operations. Get your Partnership Registration
                        expertly drafted by our top legal professionals—contact us today!</p>

                     <p className="pd-text">When entering into a partnership for a business or establishment, it is essential to prepare a Partnership Registration
                        —an agreement that details all terms and conditions for each partner to prevent future legal disputes. This document serves as a guide for all parties on business conduct, helping to avoid misunderstandings, conflicts, and potential grievances among partners.</p>

                     <p className="pd-text">Prepared under the Indian Partnership Act of 1932, the Partnership Registration
                        helps eliminate ambiguities. While it's possible to form a partnership without registration, registering your partnership firm under the Indian Registration Act offers security against future uncertainties. Seeking professional legal guidance is strongly recommended when drafting a Partnership Registration
                        . If you’re planning to start a partnership business, you’re in the right place; our expert legal team will assist you with everything necessary to establish a comprehensive Partnership Registration
                        .</p>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space80"></div>
                        <h2 className="text-center">What is a Partnership Registration
                           ?</h2>
                        <div className="space20"></div>
                        <p className="pd-text">A Partnership Registration
                           is an agreement between partners that sets out the terms and conditions of their partnership, covering aspects such as the nature of the business, the state in which the firm will operate, the structure of the partnership, and any clauses regarding dissolution, as defined under the Indian Partnership Act of 1932. </p>
                        <div className="space20"></div>
                        <p className="pd-text">While it is not mandatory to register a partnership registration
                           , registration is recommended. Registration, completed with the Registrar of Firms, offers significant benefits—it serves as a reliable reference point for resolving unforeseen conflicts between partners and safeguards their interests. A registered partnership is akin to establishing a contract with a friend before starting a business together, ensuring a stable and successful partnership.</p>
                        <div className="space20"></div>
                        <p className="pd-text">The Partnership Registration
                           acts as a roadmap, guiding the smooth operation of a business between two or more partners. It clearly defines each partner’s roles, rights, and responsibilities, helping maintain harmony within the partnership.</p>
                     </div>
                  </div>
                  <div className="col-lg-8">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <p><strong>This roadmap for a successful partnership business operation includes the following key elements:</strong></p>
                        <div className="contact6-list" >
                           <ul className="ele">
                              <li className="font-f-7 "><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Names and contributions of partners
                              </li>
                              <li className="font-f-7 "><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Profit and loss share ratio</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Duties and Decisions of each partner
                              </li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Adding or removing a partner</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Dissolution of Partnership</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                  </div>
               </div>
            </div>
         </div>


         <div className="service-binifits9 sp0" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Documents required for Partnership Registration
                           Drafting</h2>
                        <div className="service-binifits-boxs">
                           <div className="row">
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> Identity and Address Proof of
                                          Partners</strong>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> PAN Cards of Partners</strong></p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> Passport-sized Photographs of
                                          Partners</strong>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> Proof of Office Address from where the
                                          business will be operated</strong>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> Utility Bill of Registered Office
                                          Address like electricity bill</strong>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> No Objection Certificate (NOC) from the
                                          Property Owner (if applicable)</strong>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> Stamp Paper for Partnership Registration

                                          Notarization</strong>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span> <strong> Rent Agreement or registry papers of
                                          the property from where the business will be operated</strong>
                                       </p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         <div className="service-binifits9 sp0 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 data-aos="fade-up" className="aos-init aos-animate text-center">Partnership Firm Registration Fees </h2>
                        <div className="space20"></div>
                        <p className="pd-text"> The registration fees for Partnership Firm Registration can vary by state and generally fall into three main categories: Government Fees, Professional Fees, and Additional Costs. Factors such as the type of partnership and services offered by the registration authorities can also influence these fees.</p>
                        <div className="space20"></div>
                        <p className="pd-text">Government Fees primarily include Stamp Duty and charges payable during online registration on the respective government portal. These fees vary significantly across states, typically ranging from Rs.200 to Rs.2,000. Professional Fees cover services such as deed drafting, document uploading, and liaising with authorities for registration.</p>
                        <div className="space20"></div>
                        <p className="pd-text">Additional Costs may include notary charges for affidavits, stamp paper expenses, and any applicable bank charges. Online registration generally incurs lower professional fees compared to offline registration.Dm2Legal offers customized packages for drafting and registering your partnership, tailored to your specific needs. Our transparent pricing ensures there are no hidden costs.</p>
                     </div>
                  </div>
               </div>


               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Advantages of a Partnership Firm</h2>
                        <div className="space20"></div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">
                        <div className="contact6-list">
                           <ul className="ele">
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Subject to Fewer Regulations</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>One can apply for registration
                                 without any strict formalities associated with other business structures.
                              </li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Flexibility in Decision-Making</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Just like a registered firm an
                                 unregistered firm cannot enjoy certain benefits and legal protections.
                              </li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>No Mandatory Annual Filings</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">
                        <div className="contact6-list">
                           <ul >
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>No Minimum Capital Requirement</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Unlike a Limited Liability
                                 Partnership (LLP), a partnership firm is not mandated to obtain a certificate of registration.
                              </li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Conversion of type of firm is easy
                              </li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>A unique identification number or
                                 registration certificate is not mandatory for a partnership firm.
                              </li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>The registration process for a
                                 partnership firm in India is relatively less lengthy.
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Documents and Details Required for Registration </h2>
                        <div className="space20"></div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="contact6-list doc-list" >
                        <ul className="ele">
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Partnership Registration
                           </li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Form 1- Application for
                              registration which is available online
                           </li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>PAN cards of the partners</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Aadhar Cards of the partners</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="contact6-list doc-list" >
                        <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Address proofs of the partners</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Address Proof of Office Address
                              (electricity bill, rent agreement, etc.)
                           </li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Affidavit from partners per the
                              Partnership Act
                           </li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Address Proof of Office Address
                              (electricity bill, rent agreement, etc.)
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>


         <div className="space40 bg-white"></div>

         <div className="service-binifits9 sp0" id="service2">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="aos-init aos-animate">Online Registration Procedure of Partnership Firm</h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li>
                              <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>  Our legal experts will carefully review all submitted documents to reduce the risk of errors or misinformation, ensuring a smooth process.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>  Our top Partnership Registration
                                 experts are here to assist you with document requirements and all registration-related needs.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>  The assigned professional will proceed with your documents to apply for your Partnership Registration
                                 .</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>  Once your application is accepted by the Registrar of Firms, your Partnership Registration
                                 certificate will be generated.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>  Please wait until our expert contacts you to notify you of the generation of your Partnership Registration
                                 Certificate.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space40"></div>
                     </div>
                  </div>
               </div>


            </div>
         </div>

         <div className="space40 bg-white"></div>
         <div className="service-binifits9 sp0 bg-white">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Validity of Partnership Registration in India</h2>
                     </div>
                  </div>
                  <div className="col-lg-8">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <p><strong>Here are some important factors to consider regarding the validity of a registered firm:</strong>
                        </p>
                        <div className="contact6-list">
                           <ul className="ele">
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>A registered partnership firm can continue its operations as long as the partners wish to maintain it.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>A registered partnership firm allows for flexible changes in the partnership agreement, provided all partners mutually agree to the modifications.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Although not mandatory, filing proper annual returns for a registered partnership firm is highly recommended to maintain transparency and ensure compliance with legal requirements.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>The registration of a partnership firm becomes invalid upon the dissolution or termination of the partnership.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Partners must adhere to all applicable laws and regulations governing partnerships to ensure legal compliance and smooth operation of the business.</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>It is essential to follow the proper legal procedures when converting a partnership into another business structure to ensure compliance and avoid potential legal issues.</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="space30"></div>
                     <img src="assets/img/images/partnership-deed-image.jpg" alt="" />
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FAQs about Partnership Registration
                              </h2>
                              <div className="space30"></div>
                              <div id="general">
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1. Which law governs Partnership Registration in India?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Partnership registration in India is governed by the Indian Partnership Act, 1932, which defines rules for formation, rights, duties, and dissolution of partnerships.
                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading2"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2. What is the maximum number of partners allowed in a partnership firm?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse2"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          A partnership firm can have a minimum of 2 partners and a maximum of 50, as per the Companies Act, 2013.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3. Is it mandatory to register a business firm?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          No, partnership firms can operate without registration, but a registered firm gets legal benefits like the right to sue and enforce contracts.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4.  Which form is needed for partnership firm registration?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          To register a partnership firm under the Partnership Act, 1932, Form 1 must be filed with the Registrar of Firms, along with required documents.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5. What is the minimum age requirement to become a partner in a firm?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          A person must be at least 18 years old to register as a partner in a partnership firm, as per the Indian Contract Act, 1872                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6.What are the different types of partnerships in India?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500"> In India, partnerships are of three types: General Partnership, Limited Liability Partnership (LLP), and Partnership at Will, each differing in liability, registration, and legal structure.</p>

                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7. What is the timeline for Partnership Firm registration?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Registering a Partnership Firm usually takes 7 to 10 days, depending on document verification and state-specific processing times.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8. What can make a partnership firm invalid?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">A partnership may be termed invalid due to lack of a valid agreement, illegal business activities, non-compliance with the Partnership Act, 1932, or incompetent partners (e.g., minors without guardianship). </p>

                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9. What are the drawbacks of an unregistered partnership firm in India?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500"> An unregistered partnership firm cannot sue in court, enforce contracts, or claim legal benefits under the Partnership Act, 1932, limiting its legal protection.</p>

                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading3"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10. Can a foreign national become a partner in an Indian partnership firm?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse3"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, a foreign national can be a partner in an Indian partnership firm, but it requires compliance with FEMA regulations and government approvals.                                       </p>
                                    </div>
                                 </div>
                                 {/* Add additional questions here in a similar structure */}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>


            </div>
         </div>




         <Testimonials />

         <div className="sp2 last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">

                        <h2 className="aos-init aos-animate">Why choose Dm2Legal to Register a Partnership Firm</h2>
                     </div>
                  </div>
               </div>

               <div className="space30"></div>

               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box ">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4> <span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Convenient Registration</a></h4>
                           <p>With Dm2Legal, registering a partnership is quick and easy. Simply provide your name, email ID, contact number, and required service. After completing your online registration, our team will reach out to you and guide you through the next steps in the process.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                           <p>Dm2Legal is one of the leading online platforms in India, with a vast client base. We specialize in helping you with your firm registration, no matter where you are. Our online services ensure that we are always ready to assist you, providing convenient and efficient solutions.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Customer Support</a></h4>
                           <p>The Dm2Legal team is renowned for providing exceptional support and assistance to our clients. We don't just help you during the registration process; we also offer ongoing support afterward and value your feedback to continuously improve our services.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>With over 10 years of experience in the industry, we are well-versed in the registration process. By choosing us, you will benefit from working with seasoned experts who will ensure a smooth and efficient service, making the entire process easier for you.
                           </p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                           <p>Our team is committed to providing timely service without any delays. We understand the importance of your time, so we begin working on your firm registration process immediately, ensuring efficiency and promptness throughout.
                           </p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Services</a></h4>
                           <p>We offer affordable and cost-effective services without compromising on quality. With every investment you make in our services, we prioritize both your satisfaction and your budget, ensuring great value for your money.
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>




         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />



      </div>

   );
}
export default PartnershipDeed;